export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ztk-navydark px-4 pt-[68px]">
      <div className="hero-grid absolute inset-0 opacity-40" />
      <div className="absolute -left-20 top-1/4 h-80 w-80 rounded-full bg-ztk-blue/20 blur-[120px]" />
      <div className="relative w-full max-w-md py-16">
        <div className="rounded-2xl border border-white/10 bg-white p-8 shadow-2xl dark:bg-slate-900">
          <div className="mb-6 flex justify-center">
            <img src="/logo-ztkig.png" alt="ZTK" className="h-12 w-auto" />
          </div>
          <h1 className="text-center font-display text-2xl font-bold text-ztk-navy dark:text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-center text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
